<template>
    <span>
        <div class="question-name">
            <div style="cursor: pointer; width: 100%" @click.prevent="showAnswersStatus(showAnswers)">{{this.question_item.questions}}<br>
                <span style="font-size: .7rem">{{question_item.user.person.people_first_name}} {{question_item.user.person.people_surnames}}</span>
            </div>
            <div style="display: flex; flex-direction: row; justify-content: flex-end">
                <div style="display: flex; align-items: center; margin-right: 10px; cursor: pointer; padding-right: 8px"  @click.prevent="showAnswersStatus(showAnswers)">
                    <i class="fas fa-arrow-alt-circle-down fa-lg" style="color:#1EB5AB"></i>
                </div>
                <div style="display: flex; align-items: center; cursor: pointer" @click.prevent="deleteQuestion(question_item.id)" v-if="question_item.user_id == this.userId.id">
                    <i class="fas fa-trash-alt fa-sm" style="color:#FE4351" v-if="stateButon == false"></i>
                    <p v-else>Espere...</p>
                </div>
            </div>

        </div>
        <div v-if="showAnswers == true">
            <get-answers :answers="question_item.answers" :question_id="question_item.id"></get-answers>
        </div>
    </span>
</template>

<script>
    import {mapState} from 'vuex'
    import {mapGetters} from 'vuex'
    import toastr from 'toastr'
    import axios from 'axios'
    import getAnswers from './getAsnwers.vue'
    export default {
        name:'ItemQuestions',
        props:['question_item'],
        components: {
            getAnswers,
        },
        created:function () {

        },
        computed: {
            ...mapGetters([
            ]),
            userId() {
                return JSON.parse(localStorage.getItem('user'));
            },
            courseId () {
                return localStorage.getItem('mountedCourseId')
            }
        },
        data() {
            return {
                questions: '',
                showAnswers: false,
                stateButon: false
            }
        },

        methods: {
            showAnswersStatus: function (status) {

                if (status === false){
                    this.showAnswers = true;
                }else{
                    this.showAnswers = false;
                }
                console.log(this.showAnswers)
            },
            deleteQuestion: function (id) {
                this.stateButon = true
                var url = '/api/v1/students/questions/deleteQuestion';
                var token = axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('a_t');
                axios.post(url, {
                    headers: {
                        token
                    },
                    mounted_course_id: this.courseId,
                    question_id: id,
                }).then(response => {
                    if (response.data === 401){
                        toastr.error('Acción fallida... La pregunta posee respuestas asociadas');
                        this.stateButon = false
                    }else{
                        this.$store.commit('questions', response.data);
                        this.stateButon = false
                    }

                });
            }
        }
    }
</script>
<style scoped>

    .question-name{
        display:flex;
        flex-direction:row;
        background-color: white;
        border-radius: 5px;
        margin: 3px;
        width: 100%;
        align-content: center;
        justify-content: space-between;
        padding: 10px 10px 10px 10px;

        -webkit-box-shadow: 6px 6px 5px -7px rgba(194,194,194,1);
        -moz-box-shadow: 6px 6px 5px -7px rgba(194,194,194,1);
        box-shadow: 6px 6px 5px -7px rgba(194,194,194,1);
    }
</style>
